import axios from 'axios';

export const getUserDataByToken = async (token, tokenHotel) => {
    const { data } = await axios.get(`${Env.API_URL}/auth/user/token/${token}/hotelCode/${tokenHotel}`);
    return data;
};
